import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * FadeInSection — scroll-triggered blur + fade wrapper for desktop.
 * On mobile OR prefers-reduced-motion, renders children directly (no animation).
 * This prevents animations from getting stuck mid-flight on mobile viewports.
 */
export default function FadeInSection({ children, delay = 0, y = 24, className = '', once = true, amount = 0.05 }) {
  const reduce = useReducedMotion();
  const [mobile, setMobile] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const mq = window.matchMedia('(max-width: 768px)');
    const update = () => setMobile(mq.matches);
    update();
    if (mq.addEventListener) mq.addEventListener('change', update);
    else mq.addListener(update);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', update);
      else mq.removeListener(update);
    };
  }, []);

  // Skip animations on mobile / reduced-motion / SSR
  if (!mounted || mobile || reduce) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      initial={{ filter: 'blur(10px)', opacity: 0, y }}
      whileInView={{ filter: 'blur(0px)', opacity: 1, y: 0 }}
      viewport={{ once, amount, margin: '0px 0px -80px 0px' }}
      transition={{ duration: 0.8, ease: 'easeOut', delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
